<template>
  <GlobalEvents @wheel="blurIfNumberInput" />
</template>

<script>
  /**
   * Prevents value changes in number inputs when scrolling
   */
  export default {
    name: 'BlurInputOnWheelEvent',

    methods: {
      blurIfNumberInput() {
        const activeElement = document.activeElement;
        if (!activeElement) {
          return;
        }

        const isInput = (activeElement.tagName || '').toUpperCase() === 'INPUT';
        if (!isInput) {
          return;
        }

        const inputType = activeElement.getAttribute('type');
        if (inputType !== 'number') {
          return;
        }

        activeElement.blur();
      },
    },
  };
</script>
